<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>全国人大常委会２０１５年立法工作计划（２０１５年修正）123</h1>
        <div class="first">
          <p>中华人民共和国公职人员政务处分法</p>
          <p>（2020年6月20日第十三届全国人民代表大会常务委员会第十九次会议通过）</p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
        <div class="xh"></div>

        <div class="second">
          <strong>
            <p>第一章 总 则</p>
          </strong>
          <p>第一条 为了规范政务处分，加强对所有行使公权力的公职人员的监督，促进公职人员依法履职、秉公用权、廉洁从政从业、坚持道德操守，根据《中华人民共和国监察法》，制定本法。</p>
          <p>一、加强重点领域立法，做好相关法律案审议工作</p>

          <p>按照完善以宪法为核心的中国特色社会主义法律体系的要求，根据五年立法规划和常委会2015年工作要点的安排，突出重点，对2015年法律案审议工作作如下安排：</p>

          <p>（一）继续审议的法律案</p>

          <p>1 反恐怖主义法（2月）</p>

          <p>2 立法法（修改）（已通过）</p>

          <p>3 广告法（修改）（4月）</p>
          <p>4 国家安全法（4月）</p>

          <p>5 食品安全法（修改）（4月）</p>

          <p>6 境外非政府组织管理法（4月）</p>

          <p>7 刑法修正案（九）（6月）</p>

          <p>8 大气污染防治法（修改）（6月）</p>

          <p>9 资产评估法（8月）</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.date{
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
</style>